<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.728 22.737A8.783 8.783 0 0115.73 9.39a8.206 8.206 0 00-4.816-1.556c-4.559 0-8.247 3.68-8.247 8.23 0 4.548 3.688 8.229 8.247 8.229a8.207 8.207 0 004.814-1.556zm5.36 1.556c4.557 0 8.246-3.68 8.246-8.23 0-4.524-3.689-8.229-8.25-8.229a8.195 8.195 0 00-4.813 1.557 8.783 8.783 0 013.075 6.672 8.716 8.716 0 01-3.074 6.674 8.207 8.207 0 004.815 1.556zM16 10.04a8.112 8.112 0 00-2.679 6.022A8.09 8.09 0 0016 22.09a8.049 8.049 0 002.68-6.027A8.112 8.112 0 0016 10.041z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'brandMastercardSymbolFilled'
}
</script>
